import { defineComponent as _defineComponent } from 'vue'
import { vModelDynamic as _vModelDynamic, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63850cec"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "type", "name", "placeholder", "required", "disabled"]
const _hoisted_2 = ["id", "type", "name", "placeholder", "disabled", "required"]
const _hoisted_3 = { key: 2 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "6",
  height: "9",
  viewBox: "0 0 6 9",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.2041 8.9143L5.87628 4.79289C5.91551 4.75577 5.94676 4.71104 5.96812 4.66144C5.98947 4.61184 6.00049 4.5584 6.00049 4.50439C6.00049 4.45038 5.98947 4.39694 5.96812 4.34734C5.94676 4.29774 5.91551 4.25301 5.87628 4.21589L1.2041 0.094479C1.16698 0.0615286 1.12369 0.036282 1.07674 0.0202021C1.02979 0.00412221 0.980107 -0.00246958 0.930586 0.000810113C0.880666 0.00487277 0.832068 0.0189023 0.787663 0.0420699C0.743259 0.0652375 0.703951 0.0970721 0.672061 0.135693L0.0913165 0.82884C0.0585649 0.866704 0.0337331 0.910746 0.0182889 0.958367C0.00284411 1.00599 -0.00289987 1.05622 0.00139501 1.1061C0.00498608 1.15574 0.0184324 1.20417 0.0409477 1.24856C0.0634635 1.29295 0.0945971 1.3324 0.13253 1.36462L3.6732 4.4407C3.69196 4.45964 3.70249 4.48522 3.70249 4.51188C3.70249 4.53854 3.69196 4.56413 3.6732 4.58307L0.132531 7.64416C0.0601858 7.70473 0.0133556 7.79036 0.0013956 7.88395C-0.00340948 7.93357 0.0017375 7.98366 0.0165352 8.03126C0.0313324 8.07887 0.0554823 8.12305 0.0875706 8.16121L0.672062 8.87309C0.703951 8.91171 0.743259 8.94354 0.787664 8.96671C0.832068 8.98988 0.880667 9.00391 0.930586 9.00797C0.980108 9.01125 1.02979 9.00466 1.07674 8.98858C1.12369 8.9725 1.16698 8.94725 1.2041 8.9143Z",
    fill: "#a9a9a9"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 3 }
const _hoisted_7 = ["id", "type", "name"]

import { onMounted, Ref, ref, watch } from "vue";
import StrikesIcon from "../svgs/strikesIcon.vue";
import WysiwygEditor from "./wysiwygEditor.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'simpleInput',
  props: {
  type: {
    type: String,
    required: true,
  },
  classStyle: {
    type: String,
    required: false,
    default: "",
  },
  placeholder: {
    type: String,
    required: false,
    default: "",
  },
  id: {
    type: String,
    required: false,
    default: "",
  },
  name: {
    type: String,
    required: false,
    default: "",
  },
  required: {
    type: Boolean,
    required: false,
    default: false,
  },
  value: {
    type: String,
    required: false,
    default: "",
  },
  hasError: {
    type: Boolean,
    required: false,
    default: false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  isShowIcon: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: [
  "update:value",
  "on:blur",
  "on:focus",
  "on:enter",
  "click:cheron",
  "on:inputOverflow",
],
  setup(__props, { emit: $emit }) {

const props = __props;



const note = ref(props.value);
const wysiwygEditorRef: Ref<any> = ref(null);
const simpleInputRef: Ref<any> = ref(null);
const wysiwygNoteShown = ref("");
const showWysiwygEditor = ref(true);
const wysiwygEditorMaxWidth = ref(0);

watch(
  () => props.value,
  (newValue) => {
    note.value = newValue;

    if (props.type === "html-input") {
      showWysiwygEditor.value = true;
      $emit("on:inputOverflow", false);

      handleShowWysiwygEditor(newValue);
      onUpdateWysiwygEditor(newValue);
    }
  },
);



const clickCheronIcon = () => {
  $emit("click:cheron");
};

const handleWysiwygEditor = (value) => {
  const simpleInputWidth = simpleInputRef.value.scrollWidth || 0;
  const wysiwygEditorWidth =
    wysiwygEditorRef.value?.editableRef?.scrollWidth || 0;

  if (wysiwygEditorWidth === 0 || simpleInputWidth === 0) return;

  showWysiwygEditor.value = !(wysiwygEditorWidth > simpleInputWidth);
  $emit("on:inputOverflow", !showWysiwygEditor.value);

  if (!showWysiwygEditor.value && wysiwygEditorMaxWidth.value === 0)
    wysiwygEditorMaxWidth.value = value.length;
};

const onUpdateWysiwygEditor = async (value) => {
  value && handleWysiwygEditor(value);
  handleShowWysiwygEditor(value);

  await new Promise((resolve) => setTimeout(resolve, 30));
  $emit("update:value", value);
};

const onkeydown = (event) => {
  if (event.key === "Enter" || event.key === "ArrowDown") {
    event.preventDefault();
    event.stopPropagation();
    $emit("on:enter");
  }
};

const handleShowWysiwygEditor = (text: string) => {
  if (props.type !== "html-input") return;
  const temp = document.createElement("div");
  temp.innerHTML = text || "";
  wysiwygNoteShown.value = temp.textContent || temp.innerText || "";
};

onMounted(() => {
  handleShowWysiwygEditor(note.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "simpleInputRef",
    ref: simpleInputRef,
    class: "tw-relative tw-overflow-hidden"
  }, [
    (__props.type === 'input')
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          id: __props.id,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((note).value = $event)),
          type: __props.type,
          name: __props.name,
          placeholder: __props.placeholder,
          required: __props.required,
          class: _normalizeClass(`tw-flex tw-w-full tw-items-start ${__props.classStyle} ${
        __props.hasError ? 'tw-border-red-500 tw-text-[red]' : ''
      }`),
          disabled: __props.disabled,
          onInput: _cache[1] || (_cache[1] = (e) => $emit('update:value', e.target.value)),
          onBlur: _cache[2] || (_cache[2] = ($event: any) => ($emit('on:blur', note.value))),
          onFocus: _cache[3] || (_cache[3] = ($event: any) => ($emit('on:focus'))),
          onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => ($emit('on:enter')), ["enter"]))
        }, null, 42, _hoisted_1)), [
          [_vModelDynamic, note.value]
        ])
      : _createCommentVNode("", true),
    (__props.type === 'textarea')
      ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
          key: 1,
          id: __props.id,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((note).value = $event)),
          type: __props.type,
          name: __props.name,
          placeholder: __props.placeholder,
          disabled: __props.disabled,
          required: __props.required,
          class: _normalizeClass(`tw-flex tw-w-full tw-h-[46px] tw-items-start ${__props.classStyle} ${
        __props.hasError ? 'tw-border-red-500 tw-text-[red]' : ''
      }`),
          onInput: _cache[6] || (_cache[6] = (e) => $emit('update:value', e.target.value)),
          onBlur: _cache[7] || (_cache[7] = ($event: any) => ($emit('on:blur'))),
          onFocus: _cache[8] || (_cache[8] = ($event: any) => ($emit('on:focus'))),
          onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => ($emit('on:enter')), ["enter"]))
        }, null, 42, _hoisted_2)), [
          [_vModelText, note.value]
        ])
      : _createCommentVNode("", true),
    (__props.type === 'textarea')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (__props.value === '' || __props.isShowIcon)
            ? (_openBlock(), _createBlock(StrikesIcon, {
                key: 0,
                class: "tw-absolute tw-bottom-[6.93px] tw-right-[6.93px]"
              }))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "tw-absolute tw-bottom-[7.93px] tw-right-[6.93px] tw-cursor-pointer",
                onClick: clickCheronIcon
              }, _hoisted_5))
        ]))
      : _createCommentVNode("", true),
    (__props.type === 'html-input')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (showWysiwygEditor.value)
            ? (_openBlock(), _createBlock(WysiwygEditor, {
                key: 0,
                id: __props.id,
                ref_key: "wysiwygEditorRef",
                ref: wysiwygEditorRef,
                "model-value": note.value,
                "include-image": false,
                "is-disabled": __props.disabled,
                height: '38px',
                placeholder: __props.placeholder,
                "onUpdate:value": onUpdateWysiwygEditor,
                "onUpdate:blur": _cache[10] || (_cache[10] = ($event: any) => ($emit('on:blur', note.value))),
                "onUpdate:keydown": onkeydown,
                "onUpdate:focus": _cache[11] || (_cache[11] = ($event: any) => ($emit('on:focus'))),
                "onOn:ready": _cache[12] || (_cache[12] = ($event: any) => (onUpdateWysiwygEditor(note.value)))
              }, null, 8, ["id", "model-value", "is-disabled", "placeholder"]))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                id: __props.id,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((wysiwygNoteShown).value = $event)),
                type: __props.type,
                name: __props.name,
                class: _normalizeClass(`tw-flex tw-w-full tw-items-start !tw-p-[6px] !tw-text-[13px] !tw-font-normal`),
                onFocus: _cache[14] || (_cache[14] = ($event: any) => ($emit('on:focus')))
              }, null, 40, _hoisted_7)), [
                [_vModelDynamic, wysiwygNoteShown.value]
              ])
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})